import { extend } from 'vee-validate';
import { numeric } from 'vee-validate/dist/rules';

extend('numeric', numeric);
